import Vue from 'vue'
import * as rules from 'vee-validate/dist/rules'
import { ValidationProvider, ValidationObserver, extend, configure } from 'vee-validate'
import { i18n } from '@/plugins/i18n'

Object.keys(rules).forEach(rule => {
    extend(rule, {
        ...rules[rule]
    })
})

configure({
    defaultMessage: (field, values) => {
      return i18n.t(`validation.${values._rule_}`, values);
    }
})

extend('url', {
    validate: value => {
        // eslint-disable-next-line no-useless-escape
        const expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi

        const pattern = new RegExp(expression)

        return pattern.test(value)

    },
})

extend('double_or_numeric', {
    validate: value => {
        const pattern = new RegExp(/^-?\d*\.?\d*$/)

        return pattern.test(value)

    },
})

extend('sheba_number', {
    validate: value => {
        const iso7064Mod97_10 = iban => {
            let remainder = iban, block

            while (remainder.length > 2){
                block = remainder.slice(0, 9)
                remainder = parseInt(block, 10) % 97 + remainder.slice(block.length)
            }

            return parseInt(remainder, 10) % 97;
        }

        let pattern = /IR[0-9]{24}/;

        if (value.length !== 26) {
            return false;
        }

        if (!pattern.test(value)) {
            return false;
        }

        var newVaue = value.substr(4);
        var d1 = value.charCodeAt(0) - 65 + 10;
        var d2 = value.charCodeAt(1) - 65 + 10;
        newVaue += d1.toString() + d2.toString() + value.substr(2, 2);

        var remainder = iso7064Mod97_10(newVaue);
        if (remainder !== 1) {
            return false;
        }

        return true;
    },
})

const validateImageRatio = function (file, ratio) {
    let URL = window.URL || window.webkitURL
    return new Promise(function (resolve) {
        let image = new Image
        image.onerror = function () { return resolve(false) }
        image.onload = function () {
            if(typeof ratio === 'object') {
                return resolve(
                    Object.keys(ratio).some(key => image.width / image.height === ratio[key])
                )
            } else {
                return resolve(image.width / image.height === ratio)
            }
        }

        image.src = URL.createObjectURL(file)
    });
}

const imageRatio = async function (files, _a) {
    let ratio = _a.ratio
    let list = [];
    files = Array.isArray(files) ? files : [files]
    for (let i = 0; i < files.length; i++) {
        // if file is not an image, reject.
        if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
            return Promise.resolve(false)
        }
        list.push(files[i])
    }
    const values = await Promise.all(list.map(function (file) { return validateImageRatio(file, ratio) }))

    return values.some(function (v) { return v })
}

extend('image_ratio', {
    validate: imageRatio,
    params: [
        {
            name: 'ratio',
            cast: function (value) {
                return Number(value);
            }
        }
    ],
})

// FormValidator
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)